/* eslint no-undef: "off" */

import 'packs/i18n/translations';

I18n.locale = window.location.pathname.substring(1, 3);

export const searchJobs = I18n.t('search_jobs.index');
export const jobs = I18n.t('javascript.jobs');
export const industries = I18n.t('javascript.industries');
